import React from "react";

import styles from "./Section5.module.scss";

export const Section5 = function () {
  return (
    <section id="progOutline" className={`${styles.section5Wrapper} cc--component-container`}>
      <div className={styles.section5Container}>
        <div className={styles.section5Content}>
          <h3>Course Curriculum</h3>
          <div className={styles.rowContainer}>
            <div className={styles.firstCol}>
              <p>
                <strong>Module 1 Cybersecurity Risk is Business Risk</strong>
                <br />
                Learn about the risks to organizations inherent in the current cyber landscape.
              </p>
              <p>
                <strong>Module 2 Identifying the Threats to an Organization</strong>
                <br />
                Identify notable threat actors and typical methods of attack.
              </p>
              <p>
                <strong>Module 3 Identifying Important Business Systems and Assets</strong>
                <br />
                Assess the vulnerabilities of an organization&rsquo;s critical business systems, networks, and data.
              </p>
              <p>
                <strong>Module 4 The Crucial Role of Leadership in Managing Cyber Risk</strong>
                <br />
                Explore the role of leadership in managing an organization&rsquo;s cyber risk.
              </p>
            </div>
            <div className={styles.secondCol}>
              <p>
                <strong>Module 5 Understanding Your Technology</strong>
                <br />
                Identify appropriate technologies for protecting systems, networks, and data.
              </p>
              <p>
                <strong>Module 6 Cyber Risk and the Law</strong>
                <br />
                Learn to identify the legal and compliance requirements that govern an organization or sector.
              </p>
              <p>
                <strong>Module 7 Incident Response and Accountability</strong>
                <br />
                Review appropriate responses to a cyberattack.
              </p>
              <p>
                <strong>Module 8 Designing and Implementing a Mitigation Strategy</strong>
                <br />
                Develop a risk mitigation strategy for your organization.
              </p>
            </div>
          </div>
          <p className={styles.note}>
            <small>
              <em>
                Please note that module titles and their contents are subject to change during course development.
              </em>
            </small>
          </p>
        </div>
      </div>
    </section>
  );
};
